import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass";

var Datalayer = /*#__PURE__*/function () {
  function Datalayer(event, property) {
    _classCallCheck(this, Datalayer);

    this._event = event;
    this._property = property;
  }

  _createClass(Datalayer, [{
    key: "property",
    get: function get() {
      return this._property;
    },
    set: function set(value) {
      this._property = value;
    }
  }, {
    key: "event",
    get: function get() {
      return this._event;
    },
    set: function set(value) {
      this._event = value;
    }
  }]);

  return Datalayer;
}();

export default Datalayer;